// extracted by mini-css-extract-plugin
export default {"text":"Gf7qch","button":"eFlN2J"};